import { useEffect, useState } from 'react';
import { fetchDisplayFxRate } from '@/lib/displayFx';

/** Resolves the display FX rate for a selected currency (USD → currency). */
export function useDisplayFx(currency: string) {
  const [rate, setRate] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const code = (currency || '').toUpperCase();
    if (!code || code === 'USD') {
      setRate(1);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    fetchDisplayFxRate(code).then((r) => {
      if (cancelled) return;
      setRate(r);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [currency]);

  return { rate, loading };
}